import axios from "axios";
const getUserIP = async () => {
  try {
    return await axios.get("https://www.cloudflare.com/cdn-cgi/trace");
  } catch {
    return null;
  }
};

export const formatIPJSON = res => {
  if (res && res.status === 200 && res.data) {
    try {
      let data = res.data.replace(/[\r\n]+/g, '","').replace(/\=+/g, '":"');
      data = '{"' + data.slice(0, data.lastIndexOf('","')) + '"}';
      const jsondata = JSON.parse(data);
      return jsondata.ip ? jsondata.ip : null;
    } catch {
      return null;
    }
  } else {
    return null;
  }
};

export default getUserIP;
